// extracted by mini-css-extract-plugin
export default {"user-card":"UserOverlay_user-card__7hhDW","user-card-wide":"UserOverlay_user-card-wide__Zfh9P"};